import { useState } from 'react';
import SeoHead from '../../components/feature/SeoHead';
import BlogHero from './components/BlogHero';
import BlogGrid from './components/BlogGrid';
import ShareStoryCTA from './components/ShareStoryCTA';
import BlogEmailSignup from './components/BlogEmailSignup';
import Footer from '../home/components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const blogSchema = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: 'Birth Stories & Maternal Wellness Blog | Lotus Maternal',
  description: 'Inspiring birth stories from mothers in the Lotus Maternal community — home births, hospital births, VBAC journeys, and postpartum experiences.',
  url: `${siteUrl}/blog`,
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'Blog', item: `${siteUrl}/blog` },
    ],
  },
  publisher: {
    '@type': 'MedicalBusiness',
    name: 'Lotus Maternal',
    url: siteUrl,
    telephone: '(929)473-8867',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Brooklyn',
      addressRegion: 'NY',
      addressCountry: 'US',
    },
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.readdy.ai/image/0e3c418cd49273f94bb710e1b839df62/e757ad2e61eee82f71f2dc519555a206.png',
    },
  },
  inLanguage: 'en-US',
  about: [
    { '@type': 'Thing', name: 'Birth Stories' },
    { '@type': 'Thing', name: 'Postpartum Experiences' },
    { '@type': 'Thing', name: 'Maternal Health' },
    { '@type': 'Thing', name: 'Doula Support' },
  ],
};

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all');

  return (
    <>
      <SeoHead
        title="Birth Stories & Maternal Wellness Blog | Lotus Maternal Brooklyn NY"
        description="Read inspiring birth stories and maternal wellness articles from the Lotus Maternal community in Brooklyn, NY. Home births, hospital births, VBAC journeys, and postpartum experiences shared with love."
        keywords="birth stories blog, home birth stories, hospital birth, VBAC journey, postpartum experiences, maternal wellness Brooklyn, doula blog"
        canonical={`${siteUrl}/blog`}
        ogTitle="Birth Stories & Maternal Wellness Blog | Lotus Maternal"
        ogDescription="Inspiring birth stories and maternal wellness articles from the Lotus Maternal community — home births, VBAC journeys, and postpartum experiences."
        schema={blogSchema}
      />
      <div className="min-h-screen bg-white">
        <BlogHero />
        <BlogGrid selectedCategory={selectedCategory} onCategoryChange={setSelectedCategory} />
        <BlogEmailSignup />
        <ShareStoryCTA />
        <Footer />
      </div>
    </>
  );
};

export default BlogPage;